import React from 'react'
import Plot from 'react-plotly.js'
import { Card, CardContent, Typography } from '@mui/material'
import './SubmissionsByLab.scss'

export default function SubmissionsByLab({ data }) {
    if (!data || data.length === 0) {
        return (
            <Card className="submissions-by-lab-card">
                <CardContent>
                    <Typography variant="h6">Einreichungen nach Labor</Typography>
                    <Typography variant="body2" color="textSecondary">
                        Keine Daten verfügbar
                    </Typography>
                </CardContent>
            </Card>
        )
    }

    // Prepare data for horizontal bar chart
    // Reverse order so smallest values are at bottom (works better with log scale)
    const reversedData = [...data].reverse()
    const labNames = reversedData.map(lab => lab.shortName || lab.labName)
    const cases = reversedData.map(lab => lab.cases)
    const variants = reversedData.map(lab => lab.variants)

    const plotData = [
        {
            name: 'Fälle',
            x: cases,
            y: labNames,
            type: 'bar',
            orientation: 'h',
            marker: {
                color: '#1976d2'
            },
            hovertemplate: '%{x} Fälle<extra></extra>'
        },
        {
            name: 'Varianten',
            x: variants,
            y: labNames,
            type: 'bar',
            orientation: 'h',
            marker: {
                color: '#9c27b0'
            },
            hovertemplate: '%{x} Varianten<extra></extra>'
        }
    ]

    const layout = {
        title: 'Einreichungen nach Labor',
        barmode: 'stack',
        height: 400,
        margin: {
            l: 100,
            r: 50,
            t: 50,
            b: 50
        },
        xaxis: {
            title: 'Anzahl (log scale)',
            gridcolor: '#f0f0f0',
            type: 'log'
        },
        yaxis: {
            title: '',
            automargin: true,
            tickmode: 'linear',
            tick0: 0,
            dtick: 1
        },
        hovermode: 'y unified',
        showlegend: true,
        legend: {
            orientation: 'h',
            y: -0.15,
            x: 0.5,
            xanchor: 'center'
        },
        paper_bgcolor: 'white',
        plot_bgcolor: 'white'
    }

    const config = {
        responsive: true,
        displayModeBar: false
    }

    return (
        <Card className="submissions-by-lab-card">
            <CardContent>
                <Plot
                    data={plotData}
                    layout={layout}
                    config={config}
                    className="submissions-plot"
                />
            </CardContent>
        </Card>
    )
}